import React from 'react'
import { Modal, Button, Spinner } from 'react-bootstrap'
import { useGetScheduleQuery } from '../../../../services/ExpenseAnomalyApi'

type Props = {
  show: boolean
  onHide: () => void
}

const ScheduleModal: React.FC<Props> = ({ show, onHide }) => {
  const { data, isFetching } = useGetScheduleQuery(undefined, { skip: !show })
  const schedule = data?.result as any
  const frequency = schedule?.frequency ?? schedule?.Frequency
  const emails = schedule?.emails ?? schedule?.Emails

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className='fs-4'>Schedule Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isFetching ? (
          <div className='text-center py-6'>
            <Spinner animation='border' size='sm' />
          </div>
        ) : (
          <div className='d-flex flex-column gap-4'>
            <div>
              <div className='text-muted fs-7 fw-semibold mb-1'>Frequency</div>
              <div className='fs-5 fw-bold'>{frequency || '—'}</div>
            </div>
            <div>
              <div className='text-muted fs-7 fw-semibold mb-1'>Email Recipients</div>
              <div className='fs-6' style={{ whiteSpace: 'pre-wrap' }}>
                {emails || 'No emails configured'}
              </div>
            </div>
            <p className='text-muted fs-8 mb-0'>
              Frequency and recipients are managed in Org Settings (Expense Anomalies group).
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ScheduleModal
